import type { ProfileId } from '../../domain/shared/ids';
import { failure, success, type Result } from '../../domain/shared/Result';
import { RoutineError, toRoutineError } from '../errors/RoutineError';
import type { RoutinePersistenceTransactions } from '../ports/RoutinePersistenceTransactions';

/**
 * Total deletion (AC-DATA-11, AC-L0-PRIV-04). Reuses the existing atomic profile-wide delete
 * already built and tested for L3 — the philosophy corpus, being global non-personal content, is
 * untouched. A fresh default profile and seed content reappear on the next visit through the
 * existing idempotent bootstrap (InitializeLocalPersistence/SeedMvpRoutine/SeedPhilosophyCorpus),
 * exactly as on a first install — the deleted data itself never comes back.
 */
export class DeleteAllProfileData {
  public constructor(private readonly transactions: RoutinePersistenceTransactions) {}

  public async execute(profileId: ProfileId): Promise<Result<void, RoutineError>> {
    try {
      await this.transactions.deleteProfileData(profileId);
      return success(undefined);
    } catch (error) {
      return failure(toRoutineError(error));
    }
  }
}
